import { EMetal, WeightUnitType } from '@core/type';
import { SanityCharts } from '@core/type/sanity';

import { Charts } from './Charts';
import { ViewChartsWrapper } from './ViewChartsWrapper';

export type ChartPageProps = {
  shouldUseVariation?: boolean;
  cms: SanityCharts;
};

export const ViewCharts = (props: ChartPageProps) => {
  return (
    <>
      <ViewChartsWrapper
        metal={props.cms?.body?.metal as EMetal}
        weightUnit={props.cms?.body?.weightUnit as WeightUnitType}
      >
        <Charts {...props} />
      </ViewChartsWrapper>
    </>
  );
};
